import React from 'react'
import styled from 'styled-components/macro'
import {
  CATCH_BOARD_MOMENTUM_TONE,
  getCatchBoardMomentumStripModel,
} from 'src/utils/catchBoardMomentum'
import { CATCH_BOARD_TOOLTIPS } from 'src/utils/catchBoardTooltips'

const TONE_COLOURS = Object.freeze({
  [CATCH_BOARD_MOMENTUM_TONE.POSITIVE]: '#2F6B5A',
  [CATCH_BOARD_MOMENTUM_TONE.NEGATIVE]: '#A94442',
  [CATCH_BOARD_MOMENTUM_TONE.NEUTRAL]: '#6B7280',
  [CATCH_BOARD_MOMENTUM_TONE.MUTED]: '#6B7280',
})

/**
 * Muted WoW % mark for the Catch Board status strip.
 */
export function CatchBoardMomentumDelta({ change, testId }) {
  if (!change?.label) {
    return null
  }

  const tip = CATCH_BOARD_TOOLTIPS.momentum

  return (
    <Delta
      $tone={change.tone}
      title={tip}
      aria-label={`${change.label}. ${tip}`}
      data-testid={testId}
      data-tone={change.tone}
    >
      {change.label}
    </Delta>
  )
}

/**
 * Renders open-pipeline WoW cues beside Pipeline £ / deal count.
 * Returns null when momentum is missing (loading / empty API).
 */
function CatchBoardMomentumStrip({
  momentum,
  showDealCount = false,
  showDealValue = false,
}) {
  const model = getCatchBoardMomentumStripModel(momentum)
  if (!model) {
    return null
  }

  const showCount = showDealCount && model.dealCountChange
  const showValue = showDealValue && model.dealValueChange
  if (!showCount && !showValue) {
    return null
  }

  const tip = CATCH_BOARD_TOOLTIPS.momentum

  return (
    <Strip data-testid='catch-board-momentum' title={tip}>
      {showValue ? (
        <CatchBoardMomentumDelta
          change={model.dealValueChange}
          testId='catch-board-momentum-value'
        />
      ) : null}
      {showCount ? (
        <CatchBoardMomentumDelta
          change={model.dealCountChange}
          testId='catch-board-momentum-count'
        />
      ) : null}
    </Strip>
  )
}

const Strip = styled.span`
  display: inline-flex;
  align-items: baseline;
  gap: 0.35rem;
  margin-left: 0.35rem;
`

const Delta = styled.span`
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: ${({ $tone }) => TONE_COLOURS[$tone] || TONE_COLOURS.muted};
  opacity: 0.9;
`

export default CatchBoardMomentumStrip
